export default "__VITE_ASSET__TEn$aB0e__"